
import { defineComponent, ref } from "vue";

import { FormField } from "@tager/admin-ui";

type Props = Readonly<{
  description: string;
}>;

export default defineComponent({
  name: "DescriptionBlock",
  components: { FormField },
  props: {
    description: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const isOpen = ref<boolean>(!!props.description);

    function showDescriptionField() {
      isOpen.value = !isOpen.value;
    }

    return { isOpen, showDescriptionField };
  },
});
